// extracted by mini-css-extract-plugin
module.exports = {"logout_wrapper":"Cometchat_logout_wrapper__qACuB","logo_wrapper":"Cometchat_logo_wrapper__edxz8"};